import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	// Override the updateBgStyle method to include objectPosition for background alignment
	updateBgStyle() {
		if (this.backgroundData) {
			if (this.backgroundData.useSolidBgColor) {
				return;
			}

			this.setState({
				backgroundStyle: {
					backgroundImage: this.getBgImage(),
					backgroundPosition: this.getBgValue('bgPosition'),
					objectPosition: this.getBgValue('bgPosition'), // Added objectPosition for background alignment
				},
				fallbackBackgroundStyle: { objectPosition: this.getBgValue('bgPosition') }
			});
		} else {
			this.setState({
				backgroundStyle: {},
				fallbackBackgroundStyle: {}
			});

		}
	}
}
